import {MobileIcon} from '@blesk-frontend/ui';
import {AppPageWrapper} from '@/components';
export const MobilePage = () => {
  return (
    <AppPageWrapper>
      <div className="mx-auto max-w-lg p-4">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-6">
            <MobileIcon className="size-16" />

            <h1 className="text-center text-title-h1">
              Похоже, вы зашли
              <br /> с телефона
            </h1>

            <p className="text-center text-paragraph-md text-text-secondary">
              Блеск создаёт пошаговые инструкции в&nbsp;процессе работы с&nbsp;приложениями.
              Для&nbsp;этого требуется настольный компьютер или&nbsp;ноутбук. Мобильные устройства
              мы&nbsp;пока не&nbsp;поддерживаем.
            </p>
          </div>
        </div>
      </div>
    </AppPageWrapper>
  );
};
